import { createSlice } from '@reduxjs/toolkit';

export const contratosSlice = createSlice({
    name: 'contratos',
    initialState: {
        contratos_list: [],
        contrato: {}
    },
    reducers: {
        setContratosListRedux: ( state, { payload } ) => {
            state.contratos_list  =  payload;
        }, 
        setContratoRedux: ( state, { payload } ) => {
            state.contrato  =  payload; 
        }
    }
});

export const { setContratosListRedux, setContratoRedux } = contratosSlice.actions;
